<script lang="ts" setup>
import AdminConfigBranchesBranch from '@/components/AdminConfigBranches/AdminConfigBranchesBranch.vue';
import {
  computed, onMounted, ref,
} from 'vue';
import ProductCategoryInterface from '@/interfaces/ProductCategoryInterface';
import BranchConfigurationInterface from '@/interfaces/BranchConfigurationInterface';
import IoProductAPI from '@/api/IoProductAPI';

const hiddenBranchSettingsField = document.querySelector('[name="io_branch_settings"]') as HTMLInputElement;
const defaultSettings = JSON.parse(hiddenBranchSettingsField?.value || '[]') as BranchConfigurationInterface[];
if (hiddenBranchSettingsField) {
  hiddenBranchSettingsField.remove();
}

const configuredBranches = ref<BranchConfigurationInterface[]>(defaultSettings.map((configuredBranch) => {
  const updatedBranch = configuredBranch;

  if (!updatedBranch.customColor) {
    updatedBranch.customColor = {
      primary: undefined,
      secondary: undefined,
    };
  }

  if (!updatedBranch.images) {
    updatedBranch.images = {
      priceshow: undefined,
    };
  }

  return updatedBranch;
}));
const categories = ref<ProductCategoryInterface[]>([]);
const branchConfigJson = computed(() => JSON.stringify(configuredBranches.value));

const isFetching = ref(true);
onMounted(() => {
  IoProductAPI.getCategories(true).then((fetchedCategories) => {
    categories.value = fetchedCategories;
  }).finally(() => {
    isFetching.value = false;
  });
});

const deleteBranch = (index: number) => {
  const branchToDelete = configuredBranches.value[index];

  if (!branchToDelete) return;

  configuredBranches.value.splice(index, 1);
};

const addNew = () => {
  configuredBranches.value.push({
    id: Date.now(),
    name: '',
    isUrl: false,
    url: undefined,
    customIcon: undefined,
    slug: '',
    iconOrImage: undefined,
    customIconOrImage: undefined,
    category: undefined,
    dynamicTariffs: 'disabled',
    subcategories: [],
    subcategoriesExcept: [],
    customColor: {
      primary: undefined,
      secondary: undefined,
    },
    images: {
      priceshow: undefined,
    },
  });
};
</script>

<template>
  <div id="admin-config-branches">
    <div
      class="loader"
      v-show="isFetching"
    >
      <div>
        <i class="fa-solid fa-spinner fa-pulse" />
      </div>
    </div>
    <input
      type="hidden"
      style="opacity: 0; visibility: hidden; pointer-events: none; position: absolute;"
      :value="branchConfigJson"
      name="io_branch_settings"
    />
    <AdminConfigBranchesBranch
      v-for="(configuredBranch, inx) in configuredBranches"
      :key="`configured-branch--${configuredBranch.id}`"
      :index="inx"
      :num-branches="configuredBranches.length"
      :categories="categories"
      v-model="configuredBranches[inx]"
      @delete="deleteBranch"
    />
    <div class="add-new">
      <input
        type="button"
        class="button button-primary"
        value="Neue Sparte anlegen"
        @click.prevent="addNew"
      >
    </div>
  </div>
</template>

<style lang="scss">
@import "../scss/component-helpers";

#io-admin {
  #admin-config-branches {
    position: relative;

    .delete {
      font-size: 16px;
      color: red;
      position: absolute;
      top: 5px;
      right: 5px;
      border: none;
    }

    .loader {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, .625);
      z-index: 2;

      > div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
        color: $body-color;
        pointer-events: none;
        @include responsive-size-xl(60);
      }
    }
  }
}
</style>
